// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__zwaWr","avatar":"FeatureCard_avatar__lWy0j","button":"FeatureCard_button__ncZQ9"};